// extracted by mini-css-extract-plugin
export var container = "Credits-module--container--0bc69";
export var text = "Credits-module--text--d21c9";